import { Component, OnInit } from '@angular/core';
import { FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { TranslateService } from '@ngx-translate/core';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { TransitRequestDto } from 'src/app/front-user/services/e-booking/transit-request/transit-request.model';
import { first } from 'rxjs/operators';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';

@Component({
  selector: 'app-treasury-confirm-final-payment',
  templateUrl: './treasury-confirm-final-payment.component.html',
  styleUrls: ['./treasury-confirm-final-payment.component.css']
})
export class TreasuryConfirmFinalPaymentComponent implements OnInit {

  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  treasuryFinalConfimPaymentForm: FormGroup;
  AntipollutionPaymentForm: FormGroup;
  displayedLang: Languages;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  submitted: boolean = false;
  user: User = new User();
  showRequest: boolean = false;
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  error: any = { isError: false, errorMessage: '' };
  transitData: TransitRequestDto = new TransitRequestDto();
  responseObj: ResponseObject = new ResponseObject();


  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean =false;

  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices, private route: ActivatedRoute, private router: Router,
    private translate: TranslateService, private adminSrv: TransitAdminService,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private transitSrv: TransitService) {

    this.displayedLang = this.globalSrv.getLanguage()
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }
    else{
      window.history.back();
    }
    this.user = this.globalSrv.user;
    // this.baseRequestId = '43C1719C-46A9-4F28-AE3C-589AFE4542E3';

  }

  ngOnInit() {
    this.buildForm();
    this.buildAntipollutionForm();
    this.getAntipollutionData();
  }

  buildForm() {
    this.treasuryFinalConfimPaymentForm = this.formBuilder.group({
      IsAgentPayedTotal: ['', [Validators.requiredTrue]],
      TotalFees: new FormControl({ value: this.FeesEstimateObj.TotalFees, disabled: true }),
      ChequeNumber: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      MeasureExtraFee: ['', [Validators.maxLength(150)]],
      MeasurementDescription: ['']
    });

  }

  buildAntipollutionForm() {
    this.AntipollutionPaymentForm = this.formBuilder.group({
      IsAgentPayedAntipollutionFees: new FormControl({value:'', disabled: true }),
      AntipollutionFees: new FormControl({value:'', disabled: true }),
      AntipollutionPaymentDate: new FormControl({value:'', disabled: true }),
    });
    this.AntipollutionPaymentForm.disable();
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        if (history.state.data && history.state.data.isCompleted) {
          this.getTransitRequest();
        }
        else if (this.requestStatus == ServiceStatus.PendingOnTreasuryOfficerConfirmation) {
          this.formMode = FormMode.Add;
          this.treasuryFinalConfimPaymentForm.enable();
          this.treasuryFinalConfimPaymentForm.controls.TotalFees.disable();
          this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
            (resObj: ResponseObject) => {

              this.responseObj = resObj;
              if (this.responseObj.Success) {
                this.transitData = resObj.Data;
                this.treasuryFinalConfimPaymentForm.patchValue({
                  MeasureExtraFee: this.transitData.MeasureExtraFee,
                  MeasurementDescription: this.transitData.MeasurementDescription
                });
                this.treasuryFinalConfimPaymentForm.controls.MeasureExtraFee.disable();
                this.treasuryFinalConfimPaymentForm.controls.MeasurementDescription.disable();
              }
            });

        }
        else {
          this.getTransitRequest();
        }
      }
    )
  }

  public getTransitRequest() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;
          this.treasuryFinalConfimPaymentForm.patchValue({
            IsAgentPayedTotal: this.transitData.IsAgentPayedTotal,
            ChequeNumber: this.transitData.ChequeNumber,
            MeasureExtraFee: this.transitData.MeasureExtraFee,
            MeasurementDescription: this.transitData.MeasurementDescription
          });

          this.formMode = FormMode.Readonly;
          this.treasuryFinalConfimPaymentForm.disable();
        }
      });
  }

  get f() {
    return this.treasuryFinalConfimPaymentForm.controls;
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.treasuryFinalConfimPaymentForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.adminDecisionObject = this.treasuryFinalConfimPaymentForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.RequestId = this.baseRequestId;

    this.adminSrv.treasuryFinalConfirmPayment(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.treasuryFinalConfimPaymentForm.reset();
            this.showRequest = true;
            this.isErrorMessage = false;
          } else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            // this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));
            this.isErrorMessage = true;
          }

        });
  }

  receiveFeesValue($event) {
    this.FeesEstimateObj = $event;
    if (this.baseRequestId && this.FeesEstimateObj) {
      this.treasuryFinalConfimPaymentForm.patchValue({
        TotalFees: this.FeesEstimateObj.TotalFees,
      });
    }
  }

  onChangeChequeNumber(event) {

    let chequeNumber = event.target.value;
    let controls = this.treasuryFinalConfimPaymentForm.get('ChequeNumber');
    if (chequeNumber) {
      this.adminSrv.checkDuplicateChequeNumber(chequeNumber).subscribe((data: ResponseObject) => {
        if (!data.Success) {
          // this.error = { isError: true, errorMessage: this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]) };
          //controls.setErrors({ 'invalid': true });
          controls.setErrors({ duplicatedNumber: true });
        }
        else {
          // this.error = { isError: false, errorMessage: '' };
          controls.setErrors(null);
          controls.setValidators([Validators.required, CustomValidators.textSpaceValidator()]);
          controls.updateValueAndValidity();
        }

      });
    }

  }

  public getAntipollutionData() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;
          // Antipollution Payment Data
          this.AntipollutionPaymentForm.patchValue({
            IsAgentPayedAntipollutionFees: resObj.Data['AntipollutionFeesPaid'],
            AntipollutionFees: resObj.Data['AntipollutionPaymentValue'],
            AntipollutionPaymentDate: resObj.Data['AntipollutionPaymentDate']

          });
        }
      });
  }
}
